import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { homepageArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            {t("nav.guides")}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t("articles.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("articles.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {homepageArticles.map((article) => {
            const cardContent = (
              <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 h-full flex flex-col cursor-pointer">
                <div className="aspect-[8/5] overflow-hidden bg-background-200/50">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-400">•</span>
                    <span className="text-xs text-foreground-500">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                    {article.summary}
                  </p>
                  <div className="flex flex-wrap items-center gap-1.5 mt-auto">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 bg-background-200/60 text-foreground-500 text-xs rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );

            if (article.isExternal && article.externalUrl) {
              return (
                <a
                  key={article.id}
                  href={article.externalUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block"
                >
                  {cardContent}
                </a>
              );
            }

            return (
              <Link key={article.id} to={article.slug}>
                {cardContent}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}